<template>
  <div class="Page Home">

    <div class="Home__cover" :class="{ 'is-blur': open_email }">
      <video muted autoplay loop playsinline  :src="require('./video/video.mp4')" />
        <div class="Home__video-layer" />
    </div>

    <div class="Home__all">

      <div class="Home__lang" @click="$root.langSwitch()">
        {{ lang == 'fr' ? 'en' : 'fr' }}
      </div>

      <div class="Home__all-logo">
        <div class="Home__logo">
          <img :src="require('@/commons/img/logo_alegria.png')" />
        </div>
        <div class="Home__logo-title">{{ trans('presented') }}</div>
        <div class="Home__logo is-small">
          <img :src="require('@/commons/img/logo_sunlife_' + lang + '.png')" />
        </div>
      </div>

      <div class="Home__back" v-if="open_email" @click="open_email = false">
        <img :src="require('./img/Arrow-Left.png')" />
      </div>

      <transition name="Home__middle" mode="out-in">
        <div class="Home__middle" :key="open_email ? 'open' : 'close'">
          <template v-if="!open_email">
            <div class="Home__description" v-html="trans('description')" />
            <div class="Btn is-facebook" @click="loginFB">
              <img :src="require('./img/facebook.png')" />
              {{ trans('facebook') }}
            </div>
            <div class="Home__email-btn" @click="openMail" v-html="trans('login')" />
          </template>

          <div class="Home__email" v-if="open_email">
            <input :class="{ 'is-error': error }" class="Home__input Btn" type="email" :placeholder="trans('placeholder')" v-model="email_input" />
            <div v-if="error" class="Home__input-error" />
            <div class="Home__checkbox">
              <input type="checkbox" ref="checkbox" />
              <label>{{ trans('label') }}</label>
            </div>
            <div class="Btn is-gold" @click="validateMail">{{ trans('submit') }}</div>
          </div>
        </div>
      </transition>

      <FooterComp />

    </div>

  </div>
</template>

<script>
import Page from '@/core/mixins/Page'
import FooterComp from '@/components/footer/Footer'

export default {
  name: 'Home',
  mixins: [Page],
  components: { FooterComp },
  translations: {
    en: {
      presented: 'PRESENTED BY',
      description: 'Slip into the realm of Alegría via Augmented Reality',
      facebook: 'Log in with Facebook',
      login: 'Access via email',

      label: "I'd like to get information about Club Cirque, offering me early tickets and best prices.",
      submit: 'Submit',
      nocam: `
        Oh! Please use safari!<br><br>
        This experience uses the cameras of your phone,
        which works using Safari.
      `,
      placeholder: 'Email address',
    },
    fr: {
      presented: 'PRÉSENTÉ PAR',
      description: 'Glissez-vous dans le royaume d’Alegría grâce à la réalité augmentée',
      facebook: 'Se connecter par Facebook',
      login: 'Accéder par courriel',

      label: "J'aimerais recevoir de l'information à propos du Club Cirque, m'offrant de meilleurs prix et des billets en premier.",
      submit: 'Confirmer',

      nocam: `
        Oh! Utilisez plutôt Safari!<br><br>
        Cette experience utilise les caméras de votre téléphone,
        fonctionnant seulement avec Safari.
      `,
      placeholder: 'Adresse courriel',
    },
  },
  data: () => ({
    email_input: null,
    open_email: false,
    error: false,
  }),
  watch: {
    open_email() {
      dataLayer.push({
        "useCaseStep": { "Id": "UCS536 - Consent - Email page | PV", "trackType": "PV" },
        "event": "VPV",
        "page": {
          ...this.tracking.page,
          contentName: "consent",
          gaStep: "consent-email",
          requestURI: this.tracking.page.requestURI + "consent-email",
        },
        show: this.tracking.show
      })
    },
    email() {
      dataLayer.push({
        "useCaseStep": { "Id": "UCS538 - Consent - Completed page | PV", "trackType": "PV" },
        "event": "VPV",
        "page": {
          ...this.tracking.page,
          contentName: "consent",
          gaStep: "consent-successful",
          requestURI: this.tracking.page.requestURI + "consent-successful",
        },
        show: this.tracking.show
      })

      const form = new FormData
      form.append('email', this.email)
      form.append('checkbox', this.$refs.checkbox.checked)
      form.append('lang', this.lang)

      this.$http_origin.post('add_email', form).then(res => {
        console.log(res)
      })

      this.gotoMap()
    }
  },
  created() {
    this.gotoMap()

    dataLayer.push({
      "useCaseStep": { "Id": "UCS534 - Consent - Start page | PV", "trackType": "PV" },
      "event": "PV",
      page: {
        ...this.tracking.page,
        contentName: 'consent',
        gaStep: 'consent-start',
        requestURI: this.tracking.page.requestURI + 'consent-start',
      },
      show: this.tracking.show
    })
  },
  methods: {
    gotoMap() {
      if(this.$route.meta.name == 'home' && this.email)
        this.$router.push({ name: 'map.' + this.lang })
    },
    openMail() {
      this.open_email = true

      dataLayer.push({
        "useCaseStep": { "Id": "UCS535 - Consent - Selection method | Non PV", "trackType": "Non PV" },
        "event": "userAction",
        "eventCategory": "AR-event",
        "eventAction": "AlegriaAR-Login",
        "eventLabel": "Email"
      })
    },
    loginFB() {
      dataLayer.push({
        "useCaseStep": { "Id": "UCS535 - Consent - Selection method | Non PV", "trackType": "Non PV" },
        "event": "userAction",
        "eventCategory": "AR-event",
        "eventAction": "AlegriaAR-Login",
        "eventLabel": "Facebook"
      })


      FB.login(response => {
				if(response.authResponse) {
					FB.api('/me', {fields: 'name, email'}, response =>  {
						this.email_input = response.email
						this.$store.commit('user/SET_FACEBOOK')
						this.open_email = true
					})
				}
			}, {scope: 'email'})
    },
    validateMail() {
      const regex = /\S+@\S+\.\S+/
      if(regex.test(this.email_input)) {
        this.$store.commit('user/SET_EMAIL', { email: this.email_input, lang: this.lang, checkbox: this.$refs.checkbox.checked })
      } else {
        dataLayer.push({
          "useCaseStep": { "Id": "UCS537 - Consent - Error messages | Non PV", "trackType": "Non PV" },
          "event": "userAction",
          "eventCategory": "Forms error",
          "eventAction": "AlegriaAR-Login",
          "eventLabel": "Invalid email"
        })
        this.error = true
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Home
  height 100%
  width 100%
  overflow hidden

  &__lang
    position fixed
    right 20px
    top 27px
    color gold-light
    z-index 9999999999
    font-weight 700
    text-transform uppercase
    font-size 12px


  &__description
    font-size 14px
    text-transform uppercase
    margin 0 20px
    font-size 15px
    line-height 20px
    font-weight bold
    letter-spacing .05em
    margin-bottom 26px
    margin-top 300px
    text-shadow 0px 0px 5px rgba(black, .7)

  &__middle
    transition opacity .5s, transform .5s
    &-enter
    &-leave-active
      opacity 0
      transform scale(.95)


  &__email-btn
    font-size 13px
    font-weight 600
    letter-spacing .05em
    margin-top 20px
    padding 10px

  &__back
    position fixed
    left 20px
    top 24px
    width 18px

  &__nocam
    background-image url('./img/nocam.png')
    width 270px
    height 271px
    background-size contain
    position relative
    margin 0px auto
    &-text
      position absolute
      top 50%
      left 50px
      right 50px
      transform translateY(-50%)
      line-height 24px
      font-size 18px

  &__all
    padding-top 24px
    text-align center
    height 100%
    width 100%
    overflow-y auto
    overflow-x hidden
    -webkit-overflow-scrolling touch

  &__cover
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    transition filter 1s, transform 1s
    // background-image url('./img/bg.jpg')
    background-image url('./img/video.jpg')
    background-size cover
    background-position top center
    z-index -1
    video
      object-fit cover
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      width 100%
      height 100%
    &.is-blur
      filter blur(15px)
      transform scale(1.1)

  &__video-layer
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(black, .4)

  &__logo-title
    font-size 9px
    font-weight 700
    margin 10px 0
    letter-spacing .05em

  &__logo
    width 152px
    margin 0 auto
    &.is-small
      width 125px

  &__all-logo
    position fixed
    width 100%

  &__input
    border none
    color white
    display block
    text-align left
    padding-left 30px
    margin 0
    text-transform none
    width 100%
    box-sizing border-box
    border 3px solid transparent
    color black
    &::placeholder
      color grey
    &.is-error
      border-color #EA0919
      &::placeholder
        color #EA0919

  &__input-error
    width 20px
    height 20px
    background-image url('./img/error.png')
    background-size contain
    position absolute
    z-index 2
    right 18px
    top 15px

  &__email
    margin 40px 50px
    margin-top 200px
    position relative
    .Btn
      margin-top 30px

  &__checkbox
    text-align left
    margin-top 20px
    position relative
    font-weight 700
    input
      position relative
      float left
      width 20px
      display block
      z-index 9
      opacity 0
      &:checked + label:after
        display block

    label
      font-size 14px
      margin-left 30px
      line-height 20px
      display block
      &:before
        content ''
        position absolute
        left 0px
        top 0px
        width 16px
        height 16px
        border-radius 3px
        background white
      &:after
        content ''
        position absolute
        left 3px
        top 5px
        width 10px
        height 8px
        background-image url('./img/check.png')
        background-size contain
        display none



</style>
